import { render, staticRenderFns } from "./CreateVessel.vue?vue&type=template&id=7ff2500e&scoped=true&"
import script from "./CreateVessel.vue?vue&type=script&lang=js&"
export * from "./CreateVessel.vue?vue&type=script&lang=js&"
import style0 from "./CreateVessel.vue?vue&type=style&index=0&id=7ff2500e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff2500e",
  null
  
)

export default component.exports